import { render, staticRenderFns } from "./ColorReport.vue?vue&type=template&id=62d0f720&scoped=true"
import script from "./ColorReport.vue?vue&type=script&lang=js"
export * from "./ColorReport.vue?vue&type=script&lang=js"
import style0 from "./ColorReport.vue?vue&type=style&index=0&id=62d0f720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d0f720",
  null
  
)

export default component.exports